import { userErrorFragment } from './fragmentGeneral.gql';
import cartFragment from './fragmentCart.gql';

const cartAttributesUpdate = (
	`mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
		cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
			userErrors ${userErrorFragment}
			cart ${cartFragment}
		}
	}`
);

export default cartAttributesUpdate;
